import cn from "clsx";

import styles from "./Timestamp.module.scss";
import { FromDateTime } from "./FromDateTime/FromDateTime";

const Timestamp = ({
  dateTime,
  showRelativeTime = false,
  bylineFormat = false,
  className,
}: {
  dateTime?: string;
  showRelativeTime?: boolean;
  bylineFormat?: boolean;
  className?: string;
}) => {
  if (!dateTime) return null;
  return (
    <time
      role="note"
      className={cn([!className && styles.timestamp, className])}
      suppressHydrationWarning={true}
      dateTime={dateTime}
    >
      <FromDateTime
        showRelativeTime={showRelativeTime}
        bylineFormat={bylineFormat}
        dateTime={dateTime}
      />
    </time>
  );
};

export { Timestamp };
